<template>
  <div class="wc-tabs">
    <button
      v-for="tab in tabs"
      :key="tab.path"
      class="wc-tabs__item"
      :class="{ 'is-active': activePath === tab.path }"
      @click="go(tab.path)"
    >
      <svg class="wc-tabs__icon" viewBox="0 0 24 24" aria-hidden="true">
        <template v-if="tab.icon === 'schedule'">
          <rect x="3" y="4" width="18" height="17" rx="2"></rect>
          <line x1="3" y1="9" x2="21" y2="9"></line>
          <line x1="8" y1="2" x2="8" y2="6"></line>
          <line x1="16" y1="2" x2="16" y2="6"></line>
          <rect class="is-filled" x="7" y="13" width="2" height="2" rx="0.5"></rect>
          <rect class="is-filled" x="11" y="13" width="2" height="2" rx="0.5"></rect>
          <rect class="is-filled" x="15" y="13" width="2" height="2" rx="0.5"></rect>
          <rect class="is-filled" x="7" y="17" width="2" height="2" rx="0.5"></rect>
          <rect class="is-filled" x="11" y="17" width="2" height="2" rx="0.5"></rect>
        </template>
        <template v-else-if="tab.icon === 'rank'">
          <path d="M7 3h10v7a5 5 0 0 1-10 0V3Z"></path>
          <path d="M7 6H4a2 2 0 0 0 0 4h3"></path>
          <path d="M17 6h3a2 2 0 0 1 0 4h-3"></path>
          <path d="M12 15v3"></path>
          <path d="M9 21h6"></path>
        </template>
        <template v-else-if="tab.icon === 'team'">
          <path d="M9 3H15L17.5 6L21 7.5L19.5 11L17 10V21H7V10L4.5 11L3 7.5L6.5 6L9 3Z"></path>
        </template>
        <template v-else>
          <rect x="4" y="4" width="16" height="17" rx="2"></rect>
          <rect class="is-muted-fill" x="7" y="8" width="6" height="5" rx="1"></rect>
          <line x1="7" y1="16" x2="17" y2="16"></line>
          <line x1="7" y1="18.5" x2="14" y2="18.5"></line>
          <line x1="15" y1="8" x2="17" y2="8"></line>
          <line x1="15" y1="11" x2="17" y2="11"></line>
          <line x1="15" y1="13.5" x2="17" y2="13.5"></line>
        </template>
      </svg>
      <span>{{ tab.label }}</span>
    </button>
  </div>
</template>

<script>
export default {
  name: 'WorldCupMainTabs',
  data () {
    return {
      tabs: [
        { label: '赛程', path: '/worldcup2026/schedule', icon: 'schedule' },
        { label: '积分榜', path: '/worldcup2026/rank', icon: 'rank' },
        { label: '球队', path: '/worldcup2026/team', icon: 'team' },
        { label: '资讯', path: '/worldcup2026/news', icon: 'news' }
      ]
    }
  },
  computed: {
    activePath () {
      const path = this.$route.path
      if (path.indexOf('/worldcup2026/team') === 0) return '/worldcup2026/team'
      if (path.indexOf('/worldcup2026/news') === 0) return '/worldcup2026/news'
      return path
    }
  },
  methods: {
    go (path) {
      if (this.$route.path !== path) {
        const query = this.$route.query.screen ? { screen: this.$route.query.screen } : {}
        this.$router.push({ path, query })
      }
    }
  }
}
</script>

<style scoped lang="scss">
.wc-tabs {
  position: relative;
  z-index: 1;
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  height: 66px;
  background: #ffffff;
  border-bottom: 1px solid #edf0f3;
  box-shadow: 0 2px 8px rgba(17, 24, 39, .04);
}

.wc-tabs__item {
  position: relative;
  border: 0;
  background: #ffffff;
  color: #8a9099;
  font-size: 12px;
}

.wc-tabs__item.is-active {
  color: #b07d00;
  font-weight: 600;
}

.wc-tabs__item.is-active::after {
  content: '';
  position: absolute;
  left: 50%;
  bottom: 0;
  width: 28px;
  height: 3px;
  border-radius: 3px;
  background: #e0a90a;
  transform: translateX(-50%);
}

.wc-tabs__icon {
  display: block;
  width: 24px;
  height: 24px;
  margin: 8px auto 4px;
  fill: none;
  stroke: currentColor;
  stroke-width: 1.8;
  stroke-linecap: round;
  stroke-linejoin: round;
}

.wc-tabs__icon .is-filled {
  fill: currentColor;
  stroke: none;
}

.wc-tabs__icon .is-muted-fill {
  fill: currentColor;
  stroke: none;
  opacity: .35;
}
</style>
